import {VerificationChallengeDto} from "../api/model/verification-dto";
import {ChallengeNonceParams} from "../api/model/verification-challenge-submit-params";
import {WorkerPool} from "./worker-pool";

export class PowSolver {
  private workerPool: WorkerPool;

  constructor() {
    this.workerPool = new WorkerPool();
  }

  public async solveTasks(challenge: VerificationChallengeDto): Promise<ChallengeNonceParams[]> {
    const promises = challenge.tasks.map(task =>
      this.workerPool.enqueue(task, challenge.difficulty)
    );
    return Promise.all(promises);
  }

  public reset(): void {
    this.workerPool.reset();
  }
}
